import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const prodConfig = {
    apiKey: process.env.REACT_APP_PROD_API_KEY,
    authDomain: process.env.REACT_APP_PROD_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_PROD_DATABASE_URL,
    projectId: process.env.REACT_APP_PROD_PROJECT_ID,
    storageBucket: process.env.REACT_APP_PROD_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_PROD_MESSAGING_SENDER_ID,
    confirmationEmailRedirect: process.env.REACT_APP_PROD_CONFIRMATION_EMAIL_REDIRECT,
};

const stageConfig = {
    apiKey: process.env.REACT_APP_STAGE_API_KEY,
    authDomain: process.env.REACT_APP_STAGE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_STAGE_DATABASE_URL,
    projectId: process.env.REACT_APP_STAGE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STAGE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_STAGE_MESSAGING_SENDER_ID,
    confirmationEmailRedirect: process.env.REACT_APP_STAGE_CONFIRMATION_EMAIL_REDIRECT,
};

const config = prodConfig;

class Firebase {
    constructor() {
        app.initializeApp(config);

        this.emailAuthProvider = app.auth.EmailAuthProvider;
        this.auth = app.auth();
        this.db = app.database();

        this.googleProvider = new app.auth.GoogleAuthProvider();
        this.facebookProvider = new app.auth.FacebookAuthProvider();
    }

    // *** Auth API ***
    doCreateUserWithEmailAndPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignInWithGoogle = () =>
        this.auth.signInWithPopup(this.googleProvider);

    doSignInWithFacebook = () =>
        this.auth.signInWithPopup(this.facebookProvider);

    doSignOut = () => this.auth.signOut();

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password =>
        this.auth.currentUser.updatePassword(password);

    doSendEmailVerification = () =>
        this.auth.currentUser.sendEmailVerification({
            url: config.confirmationEmailRedirect,
        });

    // https://firebase.google.com/docs/auth/web/manage-users#delete_a_user
    doDeleteUser = () =>
        this.auth.currentUser.delete();

    // *** Merge Auth and DB User API *** //

    onAuthUserListener = (next, fallback) =>
        this.auth.onAuthStateChanged(authUser => {
            if (authUser) {
                this.user(authUser.uid)
                    .once('value')
                    .then(snapshot => {
                        const dbUser = snapshot.val();

                        // default empty roles
                        if (!dbUser.roles) {
                            dbUser.roles = {};
                        }

                        // merge auth and db user
                        authUser = {
                            uid: authUser.uid,
                            email: authUser.email,
                            emailVerified: authUser.emailVerified,
                            providerData: authUser.providerData,
                            ...dbUser,
                        };

                        next(authUser);
                    });
            } else {
                fallback();
            } });

    // *** User API ***
    user = uid => this.db.ref(`users/${uid}`);

    users = () => this.db.ref('users');
    expoData = (env, tataId) => {
        const envPath = env ? "/" + String(env) : ""
        const tataIdPath = env ? "/" + String(tataId) : ""
        console.log("Reading from: expoData" + envPath + tataIdPath)
        return this.db.ref('expoData' + envPath + tataIdPath)
    }
}
export default Firebase;